import styles from './ShowAd.module.css';
import Carousel from "../../../Component/Carousel/Carousel";
import HttpService from "../../Services/HttpService";
import {useEffect, useRef, useState} from "react";
import {toast} from "react-toastify";
import {json} from "react-router-dom";
import {getRowStyle, toPersianDigits} from "../../../Component/Tools/tools";
import JsonInfo from "../../../Component/JsonInfo/jsonInfo";
import Button from "../../../Component/Button/Button";


function ShowAd({id,onExit}) {

    const [infoAd, setInfoAd] = useState({
        "id": "",
        "title": "",
        "description": "",
        "phone": "",
        "jsonInfo": "[]",
        "jsonImage": "[]",
        "chatEnable": true,
        "showPhone": true,
        "location": {
            "id": 578,
            "lat": 36.2665671490045,
            "lon": 59.61518583999364,
            "city": "",
            "street": ""
        },
        "categuryInfo": {
            "name": "",
            "value": "",
            "linkUrl": ""
        },
        "condition": ""
    });

    const onTapOk = (e) => {
        HttpService.get(`Api/CheckAd?status=Ok&Id=${infoAd.id}&message=${message}`)
            .then(res => {
                if(res.status === 200){
                    toast.success('با موفقیت ثبت شد');
                    onExit();
                }
            })
            .catch(err => {
                toast.error('خطا در دریافت اطلاعات');
                setTimeout(infoAdvertisment, 3000);
            })
    }
    const onTapEdit = (e) => {
        HttpService.get(`Api/CheckAd?status=Edit&Id=${infoAd.id}&message=${message}`)
            .then(res => {
                if(res.status === 200){
                    toast.success('با موفقیت ثبت شد');
                    onExit();
                }
            })
            .catch(err => {
                toast.error('خطا در دریافت اطلاعات');
                setTimeout(infoAdvertisment, 3000);
            })
    }

    function infoAdvertisment() {
        HttpService.get(`Api/ShowAd?id=${id}`)
            .then(res => {
                setInfoAd(res.data);
            })
            .catch(err => {
                toast.error('خطا در دریافت اطلاعات');
                setTimeout(infoAdvertisment, 3000);
            })
    }

    const fetchedOnceRef = useRef(false);
    useEffect(() => {
        if (!fetchedOnceRef.current) {
            fetchedOnceRef.current = true;
            infoAdvertisment();
        }
    }, []);

    const messages = [
        `آگهی (${infoAd.title}) شما نیازمند اصلاح می باشد`,
        `آگهی (${infoAd.title}) شما تایید شد`,
        `اصلاح آگهی (${infoAd.title}) شما انجام شد`,
        'عکس آگهی شما مجاز نمی باشد',
        `مشخصات آگهی (${infoAd.title}) شما نیاز به اصلاح دارد`,
        `توضیحات آگهی (${infoAd.title}) شما نیاز به اصلاح دارد`,
        `توضیحات آگهی (${infoAd.title}) شما نیاز به اصلاح دارد لطفا از قراردادن شماره همراه و لینک سایت خودداری فرمایید.`,
    ];
    const [message, setMessage] = useState('');
    function template_message() {
        return (<div className={styles.template_message}>
            {messages.map((value, index) => {
                return <p key={index} onClick={() => setMessage(value)}>
                    {value}
                </p>
            })}
        </div>);
    }

    return (<div className={styles.container}>
        <div className={styles.container_advertisment}>
            <div className={styles.container_image}>
                <Carousel data={JSON.parse(infoAd.jsonImage)}/>
            </div>
            <div className={styles.container_properties}>
                <div className={styles.phone_condition}>
                    <h4 style={getRowStyle(infoAd.condition)}>{infoAd.condition}</h4>
                    <h4>{toPersianDigits(infoAd.phone)}</h4>
                </div>
                <h2 className={styles.title}>{toPersianDigits(infoAd.title)}</h2>
                <div>
                    <div className={styles.titre}>
                        <p>محدوده</p>
                        <p>{infoAd.location.city + ' - '+ infoAd.location.street}</p>
                    </div>
                    <hr className={styles.divider}/>
                </div>
                <JsonInfo json={infoAd.jsonInfo}/>
                <div className={styles.description}>
                    <h3>توضیحات</h3>
                    <p>{toPersianDigits(infoAd.description)}</p>
                </div>
            </div>
        </div>

        <div className={styles.container_config}>
            <div className={styles.box_message}>
                {template_message()}
                <textarea value={message}
                          onChange={(e) => setMessage(e.target.value)}/>
            </div>

            <div className={styles.container_buttons}>
                <div className={styles.button_ok}>
                    <Button text={'تایید'} onClick={onTapOk}/>
                    <Button text={'نیاز به اصلاح'} onClick={onTapEdit}/>
                </div>
                <div className={styles.button_back}>
                    <Button text={'بازگشت به لیست آگهی ها'} onClick={onExit}/>
                </div>
            </div>

        </div>
    </div>);
}

export default ShowAd;